<template>
  <v-list-item class="py-3">
    <v-list-item-content class="px-3">
      <v-list-item-title>
        {{ item.title }}
        <v-tooltip right color="error" v-if="isDeclined">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="error">error</v-icon>
          </template>
          <span>{{ $t('texts.jobDeclined', {'company': item.company_name}) }}</span>
        </v-tooltip>
        <v-tooltip right color="success" v-if="isApproved || isSystem">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="success">check_circle</v-icon>
          </template>
          <span v-if="isApproved">{{ $t('texts.jobApproved', {'company': item.company_name}) }}</span>
          <span v-else>{{ $t('texts.jobOverPlatform') }}</span>
        </v-tooltip>
      </v-list-item-title>
      <v-list-item-subtitle>{{ item.company_name }}, {{ item.place }}</v-list-item-subtitle>
      <v-list-item-subtitle>{{ getDuration(item) }}</v-list-item-subtitle>
      <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action
      :class="!$vuetify.breakpoint.xsOnly ? 'pr-3' : ''"
      :style="!$vuetify.breakpoint.xsOnly ? 'flex-direction: row; align-items: center; width: 80px' : ''"
    >
      <v-tooltip color="info" left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            :to="{ name: 'employee.resume.job', params: { id: item.id, item } }"
          >
            <v-icon color="primary">mode_edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.edit') }}</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>

</template>

<script>
import moment from 'moment';

export default {
  name: 'EmployeeResumeJobItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getDuration(item) {
      const startDate = moment([item.start_year, item.start_month - 1]);
      const formattedStartDate = this.$options.filters.formatDateMonth(startDate);
      if (item.end_year !== null && item.end_month !== null) {
        const endDate = moment([item.end_year, item.end_month - 1]);
        const formattedEndDate = this.$options.filters.formatDateMonth(endDate);
        return `${formattedStartDate} - ${formattedEndDate}`;
      }
      return `${formattedStartDate} - ${this.$i18n.t('texts.today')}`;
    },
  },
  computed: {
    isDeclined() {
      return this.item.status === 'DECLINED';
    },
    isApproved() {
      return this.item.status === 'APPROVED';
    },
    isSystem() {
      return this.item.status === 'SYSTEM';
    },
  },
};
</script>
